import moment from 'moment';

export function daysLeft(endDate: string, isOngoing: boolean) {
  return endDate && isOngoing ? moment(endDate).diff(moment().utc(), 'days') : undefined;
}
